export const categories = [
  {
    id: 'travel',
    name: '旅行探险',
    slug: 'travel',
    description: '分享旅途故事，发现世界之美',
    icon: 'ri-earth-line',
    memberCount: 28600,
    articleCount: 1842,
    image: 'https://readdy.ai/api/search-image?query=Warm%20travel%20adventure%20scene%20with%20backpack%20and%20map%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20cozy%20exploration%20atmosphere%2C%20earthy%20warm%20tones%2C%20artistic%20composition%20with%20vintage%20texture%2C%20clean%20minimal%20background&width=400&height=300&seq=cat-travel&orientation=landscape',
  },
  {
    id: 'food',
    name: '美食烹饪',
    slug: 'food',
    description: '探索舌尖上的美味，交流烹饪心得',
    icon: 'ri-restaurant-line',
    memberCount: 35200,
    articleCount: 2156,
    image: 'https://readdy.ai/api/search-image?query=Warm%20artisan%20cooking%20scene%20with%20fresh%20ingredients%20on%20wooden%20board%2C%20soft%20window%20light%2C%20rustic%20kitchen%20atmosphere%2C%20earthy%20warm%20tones%2C%20clean%20composition%20with%20organic%20textures%2C%20minimal%20background&width=400&height=300&seq=cat-food&orientation=landscape',
  },
  {
    id: 'tech',
    name: '数码科技',
    slug: 'tech',
    description: '前沿科技资讯，数码产品深度评测',
    icon: 'ri-smartphone-line',
    memberCount: 42100,
    articleCount: 3287,
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20tech%20workspace%20with%20laptop%20and%20smartphone%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20earthy%20warm%20tones%2C%20professional%20product%20photography%20style%2C%20simple%20neutral%20background&width=400&height=300&seq=cat-tech&orientation=landscape',
  },
  {
    id: 'reading',
    name: '读书思考',
    slug: 'reading',
    description: '以书会友，在阅读中遇见更好的自己',
    icon: 'ri-book-open-line',
    memberCount: 19800,
    articleCount: 1423,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20stack%20of%20books%20and%20warm%20lamp%20light%2C%20soft%20natural%20textures%2C%20peaceful%20atmosphere%2C%20earthy%20warm%20tones%2C%20artistic%20book%20photography%2C%20clean%20minimal%20background&width=400&height=300&seq=cat-reading&orientation=landscape',
  },
  {
    id: 'fitness',
    name: '运动健身',
    slug: 'fitness',
    description: '科学运动，健康生活每一天',
    icon: 'ri-heart-pulse-line',
    memberCount: 31400,
    articleCount: 1876,
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20fitness%20scene%20with%20yoga%20mat%20and%20water%20bottle%20on%20wooden%20floor%2C%20morning%20sunlight%2C%20peaceful%20wellness%20atmosphere%2C%20earthy%20warm%20tones%2C%20clean%20composition%20with%20natural%20elements%2C%20simple%20background&width=400&height=300&seq=cat-fitness&orientation=landscape',
  },
  {
    id: 'art',
    name: '艺术创作',
    slug: 'art',
    description: '用画笔和灵感，描绘多彩世界',
    icon: 'ri-palette-line',
    memberCount: 23700,
    articleCount: 1568,
    image: 'https://readdy.ai/api/search-image?query=Artistic%20studio%20scene%20with%20paintbrushes%20and%20color%20palette%20on%20wooden%20table%2C%20warm%20natural%20light%2C%20creative%20atmosphere%2C%20earthy%20warm%20tones%2C%20clean%20minimal%20composition%2C%20simple%20neutral%20background&width=400&height=300&seq=cat-art&orientation=landscape',
  },
];